import React, {useState, useContext, useEffect} from 'react';
import {Link} from 'react-router-dom';
import alertaContext from '../../context/alertas/alertaContext';
import authContext from '../../context/autenticacion/authContext';

const Login = (props) => {//props por react router dom, para luego acceder a props.history
    
    //extraer los valores del context
    const AlertaContext=useContext(alertaContext);
    const {alerta,mostrarAlerta}=AlertaContext;

    const AuthContext= useContext(authContext);
    const {iniciarSesion, mensaje,autenticado}=AuthContext;
   
    //en caso del que usuario o password no exista
    useEffect(() => { 
        if(autenticado){
            props.history.push('/proyectos') //si esta autenticado lo manda a /proyectos... 
        }
    
        if(mensaje){
            mostrarAlerta(mensaje.msg, mensaje.categoria);
                
        }
        // eslint-disable-next-line
    }, [mensaje, autenticado, props.history]);

    //state para iniciar sesion
    const [usuario, guardarUsuario] = useState({
        email:'',
        password:''
    });
    // extraer usuario
    const {email, password} = usuario;

    const handleChange = e =>{
        guardarUsuario({
          ...usuario,
          [e.target.name]: e.target.value
        })

    }

    //cuando el usuario quiere iniciar sesion
    const handleSubmit=e=>{
        e.preventDefault();
        //validar que no haya campos vacios
       if(email.trim()==='' || password.trim()===''){
        mostrarAlerta('Todos lo campos son obligatorios','alerta-error');
        return;
       }

       //inicia sesión /pasar al action
       iniciarSesion({
           password,
           email
       })

    }

    return ( 
        <div className="form-usuario">
            {alerta ? <div className={`alerta ${alerta.categoria}`}>{alerta.msg}</div>  : null}
            <div className="contenedor-form sombra-dark">
                <h1>Iniciar Sesión</h1>
                <form
                    onSubmit={handleSubmit}
                >
                    <div className="campo-form">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            placeholder="Tu email"
                            onChange={handleChange}
                            value={email}
                        />
                    </div>
                    <div className="campo-form">
                        <label htmlFor="password">password</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            placeholder="Tu password"
                            onChange={handleChange}
                            value={password}
                        />
                    </div>
                    <div className="campo-form">
                        <input
                            type="submit"
                            className="btn btn-block btn-primario"
                            value="Inicar Sesion"
                        />
                    </div>
                </form>
                <Link to={'/nueva-cuenta'} className="enlace-cuenta">
                    Obtener Cuenta
                </Link>
            </div>
        </div>
     );
}
 
export default Login;